// extracted by mini-css-extract-plugin
module.exports = {"contactPage":"ContactPage_contactPage__2A2YJ","socials":"ContactPage_socials__36DPa"};